import * as React from 'react';
import { SVGProps } from 'react';

const IconDownSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.898 9.188 2.252 6.54l-.707.707 3.853 3.854 3.854-3.854-.707-.707-2.647 2.647v-7.29h-1v7.29Z" />
  </svg>
);
export default IconDownSizeXs;
